/**
 * Суммы приходят в minor units, сгруппированные по валюте:
 * { eur: 12300, usd: 4500 } → "€123.00 · $45.00".
 */
export const formatMoneyMap = (map: Record<string, number> | undefined): string => {
    const entries = Object.entries(map ?? {}).filter(([, value]) => value !== 0);

    if (!entries.length) return '—';

    return entries
        .map(([currency, minor]) => {
            try {
                return new Intl.NumberFormat('en', {
                    style: 'currency',
                    currency: currency.toUpperCase(),
                    maximumFractionDigits: 2,
                }).format(minor / 100);
            } catch {
                return `${(minor / 100).toFixed(2)} ${currency.toUpperCase()}`;
            }
        })
        .join(' · ');
};
